__turbopack_context__.v({
  "buttons-container": "waterAccountList-module-scss-module__RKNrNq__buttons-container",
  "fade-in-unwkqtj": "waterAccountList-module-scss-module__RKNrNq__fade-in-unwkqtj",
  "report": "waterAccountList-module-scss-module__RKNrNq__report",
  "toggle": "waterAccountList-module-scss-module__RKNrNq__toggle",
  "toggle-border": "waterAccountList-module-scss-module__RKNrNq__toggle-border",
  "toggle-button": "waterAccountList-module-scss-module__RKNrNq__toggle-button",
  "toggle-button-selected": "waterAccountList-module-scss-module__RKNrNq__toggle-button-selected",
  "water-account-list": "waterAccountList-module-scss-module__RKNrNq__water-account-list",
  "water-account-list-header": "waterAccountList-module-scss-module__RKNrNq__water-account-list-header",
  "wrapper": "waterAccountList-module-scss-module__RKNrNq__wrapper",
});
